// AdminPagination.tsx — shared Prev/Next control for the admin Workspaces and Bots tables
// (Task 3, spec §4). Page-NUMBER pagination against `AdminPageMeta` (packages/shared-types/
// src/admin.ts) — the ops-only counterpart of the customer-facing cursor lists, so this is
// intentionally its own tiny component rather than reusing anything cursor-based.
import type { AdminPageMeta } from '@repo/shared-types';
import { Button } from '@repo/ui/components/button';
import { useLocale } from '../locales/context';
import { formatNumber } from '../locales/format';

export function AdminPagination({
  meta,
  onPageChange,
}: {
  meta: AdminPageMeta;
  onPageChange: (page: number) => void;
}) {
  const { t, locale } = useLocale();
  if (meta.totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between text-sm text-muted-foreground">
      <span>
        {t.admin.pagination.pageOfTotal({
          page: meta.page,
          totalPages: meta.totalPages,
          totalCount: formatNumber(meta.totalCount, locale),
        })}
      </span>
      <div className="flex gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={meta.page <= 1}
          onClick={() => onPageChange(meta.page - 1)}
        >
          {t.admin.pagination.prevCta}
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={meta.page >= meta.totalPages}
          onClick={() => onPageChange(meta.page + 1)}
        >
          {t.admin.pagination.nextCta}
        </Button>
      </div>
    </div>
  );
}
